export default `
mutation deleteBoundedContext($workflowId: ID!, $boundedContextId: ID!) {
  deleteBoundedContext(workflowId: $workflowId, boundedContextId: $boundedContextId)
}

`
